import React from 'react';
import toast from 'components/Toast';
import { toast as rawToast } from 'react-toastify';
import JEToast from 'components/Tables/toast/component';
import { get } from 'lodash';

// eslint-disable-next-line max-len
export function yieldSuccessNotification(message) {
  toast.success(message);
}
// eslint-disable-next-line max-len
export function yieldInfoNotification(message) {
  toast.info(message);
}

// eslint-disable-next-line max-len
export function yieldErrorNotification(message) {
  toast.error(message);
}

// eslint-disable-next-line max-len
export function yieldWarningNotification(message) {
  toast.warn(message);
}

export function notifyErrorFromDetail(err) {
  const errorDetail = get(err, 'response.data.detail');
  let message = 'Something went wrong';

  if (Array.isArray(errorDetail) && errorDetail.length > 0) {
    message = errorDetail[0]?.msg ?? message;
  } else if (typeof errorDetail === 'string') {
    message = errorDetail;
  }
  toast.error(message);
}

export const toastResponseError = (response) => {
  const error = get(response, 'response.data.error');

  if (typeof error === 'string') {
    return toast.error(`Failed to import data: ${error}`);
  }

  return toast.error('Import failed');
};

export function validationNotification(err) {
  if (err && err.message) {
    toast.error(err.message);
  }
  if (err && err.errors) {
    Object.keys(err.errors).forEach((errorKey) => toast.error(err.errors[errorKey]));
  }
}

export function yieldValidationNotification(err) {
  // eslint-disable-next-line max-len
  if (
    err &&
    err.response &&
    (err.response.status.toString() === process.env.REACT_APP_VALIDATION_FAILED_CODE ||
      err.response.status.toString() === process.env.REACT_APP_DUPLICATED_VALIDATION_FAILED_CODE)
  ) {
    validationNotification(err.response.data);
  }
}

export function notifyUserOfError(error) {
  const response = error?.response;
  if (response?.status === 400 && response.data?.message) {
    const message = response.data.message;
    rawToast(<JEToast text={message} type="error" />, {
      type: 'error',
      closeOnClick: false,
      autoClose: false,
      toastId: 'vendor-expenses-error',
    });
  }
}

// TODO: need to check other error paths, only checked for manual error path
//  developed only following the example of previous error handling methods
/**
 * @returns {boolean} - return result if toast was defined and appears
 */
export function handleErrorResponseWithToast(errorResponse, options = {}) {
  const originOptions = {
    path: 'data.message', // default path to get error
    type: 'error',
    defaultMessage: null,
    ...options,
  };

  const { defaultMessage, type, path } = originOptions;

  if (errorResponse && errorResponse.response) {
    const { response } = errorResponse;
    const error = get(response, path) || get(response, 'data.errors'); // alternative path to get error
    // when error is existed
    if (error) {
      if (Array.isArray(error)) {
        Object.keys(error).forEach((errorKey) => toast[type](error[errorKey]));
      } else {
        toast[type](error);
      }
      return true;
    }
    // when error is not found by path and exist default message
    if (!error && defaultMessage) {
      toast[type](defaultMessage);
      return true;
    }
  }
  // when response is undefined but exist default message
  if (defaultMessage) {
    toast[type](defaultMessage);
    return true;
  }

  return false;
}
